import { Component, Input, OnInit } from '@angular/core';
import { ElementType } from 'src/app/_objects/element-type';
import { ReportImage } from 'src/app/_objects/report-image';
import { FromToDetail } from 'src/app/_objects/report-template';
import { MousePoint, Notifier, ReportTemplateDesignService } from 'src/app/_services/report-template-design.service';

@Component({
    selector: 'app-report-image-container',
    templateUrl: './report-image.component.html',
    styleUrls: ['./report-image.component.scss'],
    standalone: false
})
export class ReportImageComponent implements OnInit {

  @Input() public pageKey: string;
  @Input() public imageKey: string;
  @Input() public elementLocation: string;

  public reportImage: ReportImage;
  private resizeMarkerSize: number;
  private resizing: boolean;

  private notifier: Notifier;
  public isCustomDrawEnable: boolean;
  constructor(
    public designService: ReportTemplateDesignService
  ) {
    this.resizeMarkerSize = 36;
    this.resizing = false;
  }

  public ngOnInit() {
    this.notifier = {
      componentName: 'report-image.component',
      ids: { pageId: this.pageKey, elementId: this.imageKey }
    };
    this.isCustomDrawEnable = this.designService.customElementAdd;
    this.reportImage = this.designService.getImage(this.imageKey);
    let elementNavigator = this.designService.navigatorElements
    .filter((x) => x.pageKey == this.pageKey)[0]
    .elementsDetails.filter((y) => y.location == this.elementLocation)[0]
      .elements;

     elementNavigator.filter(x=>x.elementName == ElementType.Image).length > 0
      ? elementNavigator.filter(x=>x.elementName == ElementType.Image)[0].elementData.push({
          id: this.imageKey,
          page: this.pageKey,
          name: this.reportImage.getTitle(),
        })
      : elementNavigator.push({
          elementName: ElementType.Image,
          isVisible: false,
          elementData: [
            {
              id: this.imageKey,
              page: this.pageKey,
              name: this.reportImage.getTitle(),
            },
          ],
        });
  }

  public onClick(event: MouseEvent) {
    if (this.reportImage.isSelectable) {
      this.designService.notifySelectElement(this.notifier, this.imageKey, event.ctrlKey);
      event.stopPropagation();
    }
  }

  public getImageUrl(fileName: string): string {
    if (fileName) {
      return this.designService.getImageUrl(fileName.split('/').pop());
    } else {
      return '';
    }
  }

  public onDragStart(event: DragEvent) {
    // console.log('ReportImage onDragStart');
    event.dataTransfer.setData('text', this.imageKey);
    event.dataTransfer.effectAllowed = 'move';

    const fromDetail: FromToDetail = {
      location: this.reportImage.getLocation(),
      pageId: this.pageKey
    };
    const dragPoint: MousePoint = {
      onElementX: event.offsetX,
      onElementY: event.offsetY
    };

    this.designService.notifyBeginDrag(this.notifier, ElementType.Image, fromDetail, dragPoint);
  }

  public onDragOver(event: DragEvent) {
    // console.log('ReportImage onDragOver');
    event.preventDefault();
    event.dataTransfer.dropEffect = 'move';
    event.stopPropagation();
  }

  public onDrop(event: DragEvent) {
    // console.log('ReportImage onDrop');
    event.preventDefault();
    const template  = {...this.designService.originTemplate};
    template.reportTemplateContent = JSON.stringify(this.designService.getTemplate());
    this.designService.templateForUndo.push(template);
    const dragElemId = event.dataTransfer.getData('text');

    const toDetail: FromToDetail = {
      location: this.reportImage.getLocation(),
      pageId: this.pageKey
    };
    const dropPoint: MousePoint = {
      onElementX: this.reportImage.getLeftPx() + event.offsetX,
      onElementY: this.reportImage.getTopPx() + event.offsetY
    };

    this.designService.notifyDrop(this.notifier, dragElemId, toDetail, dropPoint);

    event.dataTransfer.clearData('text');
    event.stopPropagation();
  }

  public getResizeMarkerSize(): string {
    return this.resizeMarkerSize + 'px';
  }

  public getResizeMarkerLeft(horizontal: string): string {
    switch (horizontal) {
      case 'left':
        return (this.resizeMarkerSize / 2 * -1) + 'px';
      case 'center':
        return ((this.reportImage.getWidthPx() / 2) - (this.resizeMarkerSize / 2)) + 'px';
      case 'right':
        return (this.reportImage.getWidthPx() - (this.resizeMarkerSize / 2)) + 'px';
      default:
        return '';
    }
  }

  public getResizeMarkerTop(vertical: string): string {
    switch(vertical) {
      case 'top':
        return (this.resizeMarkerSize / 2 * -1) + 'px';
      case 'middle':
        return ((this.reportImage.getHeightPx() / 2) - (this.resizeMarkerSize / 2)) + 'px';
      case 'bottom':
        return (this.reportImage.getHeightPx() - (this.resizeMarkerSize / 2)) + 'px';
      default:
        return '';
    }
  }

  public onResizing(event: MouseEvent) {
    event.preventDefault();
    if (this.resizing) {
      this.designService.notifyResize(this.notifier, { onElementX: event.offsetX, onElementY: event.offsetY});
    }
    event.stopPropagation();
  }

  public onResizeMarkerUp(event: MouseEvent) {
    event.preventDefault();
    this.resizing = false;
    event.stopPropagation();
  }

  public onResizeMarkerDown(event: MouseEvent, vertical: string, horizontal: string) {
    event.preventDefault();
    this.resizing = true;
    const beginPoint: MousePoint = {
      onElementX: event.offsetX,
      onElementY: event.offsetY
    };
    this.designService.notifyBeginResize(this.notifier, ElementType.Text, horizontal, vertical, beginPoint);
    event.stopPropagation();
  }

  public onResizeMarkerLeave(event: MouseEvent) {
    event.preventDefault();
    this.resizing = false;
    event.stopPropagation();
  }
}
